import config, { setConfig } from "@/config";
import axios from "axios";
// eslint-disable-next-line @typescript-eslint/ban-ts-ignore
// @ts-ignore
import { APP_ROOT } from "./env.js";

async function loadConfig(url: string): Promise<any> {
  let error: Error;

  if (process.env.VUE_APP_TARGET_ENV === "server" && !url.startsWith("http")) {
    const fs = await import("fs");
    const path = await import("path");
    return JSON.parse(await fs.promises.readFile(path.resolve(__dirname, APP_ROOT + url), "utf-8"));
  }

  for (let i = 0; i < 3; i++) {
    try {
      const response = await await axios.get(url, {
        headers: {
          "Cache-Control": "no-store",
        },
      });
      return response.data;
    } catch (e) {
      error = new Error(`Error loading config from ${url}: ${(e as Error).message}`);
      await new Promise(r => setTimeout(r, 1000));
    }
  }
  return Promise.reject(error!);
}

export default function(devConfig?: Record<string, string>) {
  if (devConfig) {
    setConfig(devConfig);
  }

  return Promise.all([
    loadConfig("/project/js/config.json"),
    loadConfig(`${config.backendUrl}/system-settings/frontend-config`),
  ]).then(configs => configs.forEach(c => setConfig(c)));
}
